import { Box } from "@mui/material";
import NoDataBanner from "components/common/NoDataBanner";
import ActionBar from "../ActionBar";
import "./ConfigTabsData.scss";

const TabsData = (props: any) => {
  const {
    dataList: list,
    type,
    tab,
    showInncode = false,
    dateDetails = false,
    showPlanDate = false,
    noDataMessage = "",
    shouldNavigate = false,
    getUrl,
    navigateState
  } = props;

  return (
    <>
      {list?.length > 0 ? (
        <Box id="actionItemsDiv1" className="tabs-data-component">
          {list.map((element: any) => {
            return (
              <ActionBar
                type={type}
                tab={tab}
                dateDetails={dateDetails}
                showPlanDate={showPlanDate}
                showInncode={showInncode}
                element={element}
                url={getUrl(element)}
                shouldNavigate={shouldNavigate}
                navigateState={navigateState}
              />
            );
          })}
        </Box>
      ) : (
        <NoDataBanner noDataMessage={noDataMessage} />
      )}
    </>
  );
};
export default TabsData;
